__turbopack_context__.v({
  "c_batch": "Menu-module__exN1ha__c_batch",
  "c_menu": "Menu-module__exN1ha__c_menu",
  "c_menu_body": "Menu-module__exN1ha__c_menu_body",
  "c_menu_button": "Menu-module__exN1ha__c_menu_button",
  "c_menu_contents": "Menu-module__exN1ha__c_menu_contents",
  "c_menu_icon": "Menu-module__exN1ha__c_menu_icon",
});
